export const bsmCourses = [
    { 
      title: "Expose on Exfoliation", 
      code: "BSM 111", 
      outline: "1. What is exfoliation?\n2. Importance of exfoliation in a skincare routine.\n3. How exfoliation works.\n4. Different exfoliants for the skin.\n5. Assignments" 
    },
    { 
      title: "Introduction to body scrub making", 
      code: "BSM 112", 
      outline: "1. What are emulsified scrubs?\n2. What are foaming scrubs?\n3. What are body polishes/creamy scrubs?\n4. What is a single ingredient scrub? \n5. Combination of physical and chemical exfoliants in one scrub. \n6. How to select ingredients for body scrub making \n7. How to select exfoliant base for body scrubs. \n8. Assignment" 
    },
    { 
      title: "Formula creation and conversion", 
      code: "BSM 113", 
      outline: "1. What is a formula?\n2. How to create a formula. \n3. Methods of converting formulas to recipes.\n4. Importance of creating a formula.\n5. Simple body scrub formula. \n6. Asseignment." 
    },
    { 
      title: "Emulsified body scrubs", 
      code: "BSM 114", 
      outline: "1. How to formulate a simple emulsified scrub.\n2. How to formulate single ingredient emulsified scrub.\n3. How to formulate multi-ingredients emulsified scrub.\n4. How to formulate an emulsified scrub with chemical exfoliants.\n5. Assignment" 
    },
    { 
      title: "Foaming body scrubs", 
      code: "BSM 115", 
      outline: "1. How to formulate a simple foaming scrub.\n2. How to formulates single ingredient foaming scrub.\n3. How to formulate multi-ingredient foaming scrub.\n4. How to formulate foaming scrub with chemical exfoliants. \n5. Assignment." 
    },
    { 
      title: "Body polish/Creamy scrubs", 
      code: "BSM 116", 
      outline: "1. How to formulate a simple body polish/creamy scrub.\n2.How to formulates single ingredient creamy scrub.\n3. How to formulate multi-ingredient creamy scrub.\n4. How to formulate creamy scrubs with chemical exfoliants.\n5. Assignment." 
    },
    { 
      title: "Importance of research as a formulator", 
      code: "BSM 117", 
      outline: "1. Why do I need research as a formulator?\n2. How research improves your skill as a formulator." 
    },
];

export const bsmCourses2 = [
    {
        title: "Introduction to black soap making",
        code: "BSM 101",
        outline: "1. What is black soap?\n2. Origin of black soap.\n3. Types of black soap (base).\n4. Importance of measurement in black soap making.\n5. Benefits of black soap.\n6. Disadvantages of black soap when not properly formulated.\n7. Assignment."
    },
    {
        title: "Whitening/Lightening black soap making",
        code: "BSM 102",
        outline: "1. Ways to activate black soap to whiten and lighten skin.\n2. Types of powders that whiten or lighten and lighten skin.\n3. Types of oils to whiten and lighten skin.\n4. How to select ingredients that whiten and lighten skin.\n5. How to prevent skin irritation or reaction in whitening black soap.\n6. How to make solid black soap without water.\n7. Detailed explanation and step by step on how to make whitening/lightening black soap.\n8. Assignment."
    },
    {
        title: "Brightening black soap making",
        code: "BSM 103",
        outline: "1. Difference between whitening, lightening, brightening and glowing.\n2. Types of powders to brighten/glow skin.\n3. Types of oils to brighten/glow skin.\n4. How to select ingredients to brighten/glow skin.\n5. Step by step on how to make brightening black soap.\n6. Assignment."
    },
    {
        title: "Acne/pimple herbal black soap",
        code: "BSM 104",
        outline: "1. Types of powders that treat pimple/acne.\n2. Types of oils for acne/pimple black soap.\n3. How to select ingredients for acne/pimple black soap.\n4. Step by step on how to make black soap for acne and pimple treatment.\n5. Assignment."
    },
    {
        title: "Liquid black soap making",
        code: "BSM 105",
        outline: "1. Types of powder for liquid black soap.\n2. Types of oils for liquid black soap.\n3. How to select ingredients for liquid soap.\n4. Step by step on how to make liquid black soap."
    },
    {
        title: "Importance of research",
        code: "BSM 106",
        outline: "1. Why do I need research as a formulator?\n2. How research improves your skill as a formulator."
    },
];

export const bbmCourses = [
    {
        title: "Introduction to body butter making",
        code: "BBM 201",
        outline: "1. What are body butters?\n2. Types of body butters.\n3. Differences between body butter, creams and lotions.\n4. Types of ingredients for body butter making.\n5. How to select ingredients for body butter.\n6. Assignment"
    },
    {
        title: "Formula creation and conversion",
        code: "BBM 202",
        outline: "1. What is a formula?\n2. How to create a formula.\n3. How to convert formulas to recipes.\n4. Importance of creating a formula.\n5. Assignment."
    },
    {
        title: "All about PH",
        code: "BBM 203",
        outline: "1. What is ph?\n2. How to read ph(understanding ph).\n3. How to check ph of products.\n4. How to make PH buffer solutions to regulate (raise and lower) ph of products.\n5. Assignment."
    },
    {
        title: "An-hydrous body butter making",
        code: "BBM 204",
        outline: "1. What are anhydrous body butters?\n2. How to make a simple body butter.\n3. How to make a full brightening body butter.\n4 Secret to achieving a fluffy whipped body butter.\n5. Assignment."
    },
    {
        title: "Hydrous body butter making",
        code: "BBM 205",
        outline: "1. What are hydrous body butters?\n2. How to make a whole brightening body butter.\n3. How to check ph of body butter.\n4. How to adjust ph of body butter.\n5. Assignment"
    },
    {
        title: "Importance of research as a formulator",
        code: "BBM 206",
        outline: "1. Why do I need to keep research as a formulator.\n2. How research improves your skill as a formulator."
    },
];

export const gctFreeCourses = [
    {
        title: "Body oil making",
        code: "GCT 225",
        outline: "1. Introduction to body oil making.\n2. Types of oils.\n3. How to select oils.\n4. How to formulate a brightening body oil"
    },
    {
        title: "Research costing and marketing",
        code: "GCT 226",
        outline: "1. Importance of research as a formulator.\n2. How to properly cost your products.\n3. Importance of proper marketing."
    },
];

export const gctPaidCourses = [
    {
        title: "Expose on exfoliation",
        code: "GCT 201",
        outline: "1. What is exfoliation?\n2. Importance of exfoliation in a skincare routine.\n3. How exfoliation works.\n4. Different exfoliants for the skin."
    },
    { 
        title: "Introduction to body scrub making", 
        code: "GCT 202", 
        outline: "1. What are emulsified scrubs?\n2. What are foaming scrubs?\n3. What are body polishes/creamy scrubs?\n4. What is a single ingredient scrub?\n5. Combination of physical and chemical exfoliants in one scrub.\n6. How to select ingredients for body scrub making.\n7. How to select exfoliants base for body scrubs."
    },
    { 
        title: "Formula creation and conversion", 
        code: "GCT 203", 
        outline: "1. What is a formula?\n2. How to create a formula.\n3. Methods of converting formulas to recipes.\n4. Importance of creating a formula.\n5. Simple body scrub formula.\n6. Assignments."
    },
    { 
        title: "Emulsified body scrubs", 
        code: "GCT 204", 
        outline: "1. How to  formulate a simple emulsified scrub.\n2. How to formulate single ingredient emulsified scrub.\n3. How to formulate multi-ingredients emulsified scrub.\n4. How to formulate an emulsified scrub with chemical exfoliants."
    },
    { 
        title: "Foaming body scrubs", 
        code: "GCT 205", 
        outline: "1. How to formulate a simple foaming scrub.\n2. How to formulates single ingredient foaming scrub.\n3. How to formulate multi-ingredient foaming scrub.\n4. How to formulate foaming scrub with chemical exfoliants."
    },
    { 
        title: "Body polish/creamy scrubs", 
        code: "GCT 206", 
        outline: "1. How to formulate a simple body polish/creamy scrub.\n2. How to formulates single ingredient creamy scrub.\n3. How to formulate multi-ingredient creamy scrub.\n4. How to formulate creamy scrubs with chemical exfoliants.\n5. Assignment."
    },
    { 
        title: "Introduction to black soap making", 
        code: "GCT 211", 
        outline: "1. What is black soap?\n2. Origin of black soap.\n3. Types of black soap (base).\n4. Importance of measurement in black soap making.\n5. Benefits of black soap.\n6. Disadvantages of black soap when not properly formulated.\n7. Assignment."
    },
    { 
        title: "Whitening/Lightening black soap making", 
        code: "GCT 212", 
        outline: "1. Ways to activate black soap to whiten and lighten skin.\n2. Types of powders that whiten or lighten and lighten skin.\n3. Types of oils to whiten and lighten skin.\n4. How to select ingredients that whiten and lighten skin.\n5. How to prevent skin irritation or reaction in whitening black soap.\n6. How to make solid black soap without water.\n7. Detailed explanation and step by step on how to make whitening/lightening black soap.\n8. Assignment."
    },
    { 
        title: "Brightening black soap making", 
        code: "GCT 213", 
        outline: "1. Difference between whitening, lightening, brightening and glowing.\n2. Types of powders to brighten/glow skin.\n3. Types of oils to brighten/glow skin.\n4. How to select ingredients to brighten/glow skin.\n5. Step by step on how to make brightening black soap.\n6. Assignment."
    },
    { 
        title: "Acne/Pimple herbal black soap", 
        code: "GCT 214", 
        outline: "1. Types of powders that treat pimple/acne.\n2. Types of oils for acne/pimple black soap.\n3. How to select ingredients for acne/pimple black soap.\n4. Step by step on how to make black soap for acne and pimple treatment.\n5. Assignment."
    },
    { 
        title: "Liquid black soap making", 
        code: "GCT 215", 
        outline: "1. Types of powder for liquid black soap.\n2. Types of oils for liquid black soap.\n3. How to select ingredients for liquid soap.\n4. Step by step on how to make liquid black soap."
    },
    { 
        title: "Introduction to body butter making", 
        code: "GCT 221", 
        outline: "1. What are body butters?\n2. Types of body butters.\n3. Differences between body butter, creams and lotions.\n4. Types of ingredients for body butter making.\n5. How to select ingredients for body butter."
    },
    { 
        title: "All about PH", 
        code: "GCT 222", 
        outline: "1. What is ph?\n2. How to read ph(understanding ph).\n3. How to check ph of products.\n4. How to make PH buffer solutions to regulate (raise and lower) ph of products.\n5. Assignment."
    },
    { 
        title: "An-hydrous body butter making", 
        code: "GCT 223", 
        outline: "1. What are anhydrous body butters?\n2. How to make a simple body butter.\n3. How to make a full brightening body butter.\n4. Secret to achieving a fluffy whipped body butter.\n5. Assignment."
    },
    { 
        title: "Hydrous body butter making", 
        code: "GCT 224", 
        outline: "1. What are hydrous body butters?\n2 How to make a whole brightening body butter.\n3. How to check ph of body butter.\n4. How to adjust ph of body butter.\n5. Assignment."
    },
];
